export const rentalPlanReducer = (
  state = {
    plans: null,
    planDetail: null,
    payments: null,
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case "LIST_RENTAL_PLANS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "LIST_RENTAL_PLANS_SUCCESS":
      return {
        ...state,
        loading: false,
        plans: action.payload,
        error: null,
      };
    case "LIST_RENTAL_PLANS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "VIEW_RENTAL_PLAN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "VIEW_RENTAL_PLAN_SUCCESS":
      return {
        ...state,
        loading: false,
        planDetail: action.payload,
        error: null,
      };
    case "VIEW_RENTAL_PLAN_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "ADD_RENTAL_PLAN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADD_RENTAL_PLAN_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "ADD_RENTAL_PLAN_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_PLAN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_RENTAL_PLAN_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "UPDATE_RENTAL_PLAN_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_PLAN_STATUS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_RENTAL_PLAN_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "UPDATE_RENTAL_PLAN_STATUS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};